$(function(){
   
  
  $('.option_btn').click(function(){
    

    $('.collection_option_popup').addClass('active');
    $('.collection_option_pop_bg').addClass('active');
    var option_cont = $(this).siblings('.option_popup').html();
      $('.collection_option_popup').append(option_cont);
    $(' .option_popup_close_btn').show();
     
  });
  $('.collection_option_pop_bg,.option_popup_close_btn').click(function(){
    $('.collection_option_pop_bg').removeClass('active');
    $('.collection_option_popup').removeClass('active');
      $('.collection_option_popup').html('');
    $('.selected_option_list li').text('');
    $(' .option_popup_close_btn').hide();
  });



   
}); 